import React, { useContext } from "react";
import { IconButton, ListActionButtonProps, Stack } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { OrderListingContext } from "../context/OrderListingContext";
import { OrderListingItem } from "../OrderListingItem";

type PinOrderListingButtonProps = ListActionButtonProps<OrderListingItem>;

export const PinOrderListingButton: React.VFC<PinOrderListingButtonProps> = ({ item }: PinOrderListingButtonProps) => {
    const { togglePinnedOrder } = useContext(OrderListingContext);
    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdReadWrite]}>
            <Stack horizontal verticalAlign="center">
                <IconButton
                    iconProps={{ iconName: item.isPinned ? "PinnedSolid" : "Pinned" }}
                    styles={{
                        iconButton: {
                            flexContainer: { alignItems: "flex-start" }
                        }
                    }}
                    tooltipContent={`${item.isPinned ? "Unpin" : "Pin"} order`}
                    testId="pin-list-button"
                    onClick={() => togglePinnedOrder(item.id)}
                />
            </Stack>
        </AuthorizationWrapper>
    );
};
